<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách quản lý HĐ/PL giấy</h1>
      <div class="btn-group float-right">
        <!-- <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_SCON_SAVE_PAPER_CONTRACT_MANAGEMENT')"
          @click="exportExcel">
          <i class='bx bx-download' ></i><span>&nbsp;</span>Export File
        </button> -->
        <button class="font-medium f12 btn btn-outline-secondary" @click="onShowImportUpload">
          <i class="bx bx-download"></i><span>&nbsp;</span>Import File
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.createdBy"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.state"
              :options="Config.listStatusContract"
              placeholder="Trạng thái PL/HĐ"
            />
          </div>
          <div class="form-group">
            <input type="hidden" class="form-control text-left" v-model="merchantSelected" />
            <input
              type="text"
              class="form-control text-left"
              :value="merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''"
              placeholder="Merchant"
              @click="showModalSelectMC = true"
              v-b-modal.select-merchant-dialog
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.appendixType"
              :options="Config.getSearch(Config.typeAppendix)"
              placeholder="Loại phụ lục"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createDate"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.saveStatus"
              :options="Config.saveStatus"
              placeholder="Tình trạng lưu bản giấy"
            />
          </div>
          <!--  -->
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            <div>
              Tổng:
              <strong class="text-primary">{{ pagination?.total?.toLocaleString('vi-VN') }}</strong>
            </div>

            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(type)="{ item }">
                <p>
                  {{ item.type === 'APPENDIX' ? 'Phụ Lục' : 'Hợp đồng' }}
                </p>
                <p v-if="item.typeAppendix">
                  Loại phụ lục:
                  {{ item.typeAppendix | transformData(Config.typeAppendix) }}
                </p>
              </template>
              <template #cell(code)="{ item }">
                <p v-if="item.appendixCode">Mã PL: {{ item.appendixCode }}</p>
                <p v-if="item.contractCode">Mã HĐ : {{ item.contractCode }}</p>
              </template>
              <template #cell(createdBy)="{ item }">
                <p v-if="item.createdByName">{{ item.createdByName }}</p>
                <p v-if="item.createdByEmail">{{ item.createdByEmail }}</p>
              </template>
              <template #cell(status)="{ item }">
                <span class="badge" :class="item.status">
                  {{ item.status | transformData(Config.listStatusContract) }}
                </span>
              </template>
              <template #cell(saveStatus)="{ item }">
                <p v-if="item.saveStatus">
                  {{ item.saveStatus | transformData(Config.saveStatus) }}
                </p>
              </template>
              <template #cell(createdDate)="{ item }">
                <p v-if="item.createdDate">
                  Tạo: {{ item.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                </p>
                <p v-if="item.signDate">Ký: {{ item.signDate | formatDate('HH:mm DD/MM/YYYY') }}</p>
                <p v-if="item.approveDate">
                  Duyệt: {{ item.approveDate | formatDate('HH:mm DD/MM/YYYY') }}
                </p>
                <p v-if="item.rejectDate">
                  Từ chối: {{ item.rejectDate | formatDate('HH:mm DD/MM/YYYY') }}
                </p>
                <p v-if="item.cancelDate">
                  Hủy: {{ item.cancelDate | formatDate('HH:mm DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_SCON_SAVE_PAPER_CONTRACT_MANAGEMENT')"
                    @click="actionConfirm('ADMIN_RECEIVE', item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Admin đã nhận bản giấy
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_SCON_SA_SENT_PAPER_CONTRACT_MANAGEMENT')"
                    @click="actionConfirmSentAccoutant('SENT_ACCOUNTANT_CONFIRM', item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chuyển chờ kế toán xác nhận
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ACCOUNTANT_SAVE_PAPER_CONTRACT_MANAGEMENT')
                    "
                    @click="actionConfirmAccoutantConfirm('ACCOUNTANT_RECEIVE', item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Kế toán xác nhận đã nhận
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ACCOUNTANT_SAVE_PAPER_CONTRACT_MANAGEMENT')
                    "
                    @click="actionConfirmAccoutantConfirm('ACCOUNTANT_UNRECEIVED', item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Kế toán xác nhận không nhận
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <SelectMerchant v-if="showModalSelectMC" @selectMerchant="onSelectMerchant" />
    <ModalImportAction @closeModal="onHideImportUpload"></ModalImportAction>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import ModalImportAction from './modal/ModalImportAction.vue'
  import { mapGetters } from 'vuex'
  import { ContractService } from '@/services/contract.service'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { StaffService } from '@/services/staff.service'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import moment from 'moment'
  import { getLastNDays } from '@/utils/util'
  export default {
    name: 'contract-paper',
    data() {
      return {
        Config,
        filterTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'type', label: 'Loại' },
          { key: 'code', label: 'Mã PL/HĐ', class: 'text-center' },
          { key: 'createdBy', label: 'Người tạo', class: 'text-center' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'region', label: 'Vùng' },
          {
            key: 'createdDate',
            label: 'Ngày',
            formatter: value => this.$options.filters.formatDate(value, 'HH:mm DD/MM/YYYY'),
          },
          // { key: 'region', label: 'Tình trạng nợ bản giấy' },
          { key: 'saveStatus', label: 'Tình trạng lưu bản giấy' },
          { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
        ],
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
          createDate: {},
        },
        pagination: {
          total: 0,
        },
        dataManager: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        merchantSelected: {},
        dataConfigRegion: [],
        showModalSelectMC: true,
        hasDefaultFilter: true,
      }
    },
    components: { SelectMerchant, ModalImportAction },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      const { from, to } = getLastNDays(3, 'date')
      this.search.createDate = {
        startDate: from,
        endDate: to,
      }
      this.fetchData()
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userName, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      this.getRegions()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          createDate: {
            startDate: null,
            endDate: null,
          },
        }
        this.showModalSelectMC = false
        this.merchantSelected = {}
        this.hasDefaultFilter = false
        await this.fetchData()
      },
      removeDefaultFilter() {
        this.search.createDate = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = cloneDeep(this.search)
          if (params.createDate.endDate) {
            params.dateFrom = moment(params.createDate.startDate).startOf('day').valueOf()
            params.dateTo = moment(params.createDate.endDate).endOf('day').valueOf()
          }
          const response = await ContractService.listPaperContractManager(params)
          if (response.code === 1000) {
            this.lists = response.data.data
            this.pagination.total = response.data.paging.total
          } else {
            this.lists = []
            this.pagination.total = 0
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      onSelectMerchant(mc) {
        this.search.merchantId = mc ? mc.customerId : ''
        this.merchantSelected = mc || {}
      },
      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = [
            {
              id: 0,
              text: 'Tất cả',
            },
          ]
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },
      async actionConfirm(paperActionSaveType, id) {
        try {
          this.showLoading = true
          const data = {
            id,
            paperActionSaveType,
          }
          const res = await ContractService.actionSavePaperContract(data)
          if (res.data.code) {
            this.showSuccessMx('Thành công')
          } else this.showFailMx(res.data.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async actionConfirmSentAccoutant(paperActionSaveType, id) {
        try {
          this.showLoading = true
          const data = {
            id,
            paperActionSaveType,
          }
          const res = await ContractService.actionSavePaperContractSentAccoutant(data)
          if (res.data.code) {
            this.showSuccessMx('Thành công')
          } else this.showFailMx(res.data.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async actionConfirmAccoutantConfirm(paperActionSaveType, id) {
        try {
          this.showLoading = true
          const data = {
            id,
            paperActionSaveType,
          }
          const res = await ContractService.actionSavePaperContractAccoutantConfirm(data)
          if (res.data.code) {
            this.showSuccessMx('Thành công')
          } else this.showFailMx(res.data.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      detail(id) {
        const routeData = this.$router.resolve({ path: `/paper-contract-manager/${id}` })
        window.open(routeData.href, '_blank')
      },
      async exportExcel() {
        try {
          this.showLoading = true
          await ContractService.exportPaperContractManager(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      onShowImportUpload() {
        this.$bvModal.show('select-import-action')
      },
      onHideImportUpload() {
        this.$bvModal.hide('select-import-action')
      },
    },
  }
</script>

<style scoped>
  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
